import React, { useState } from "react";
import { Box, Button, Card, Dropdown, Grid, Icon, Table, Text } from "~/components-shared";
import styled from "styled-components";
import FindingTableRow from "~/components/insightsWidgets/FindingTableRow";
import { useTranslation } from "react-i18next";
import mixpanel from "mixpanel-browser";
import StyledIcon from "~/components/StyledIcon";
const StyledTable = styled(Table)`
  width: ${_ref => {
  let {
    theme
  } = _ref;
  return `calc(100% + ${10 * theme.typography.fontStep}rem)`;
}};
`;
const StyledTableHeader = styled(Table.Header)`
  border-bottom: 1px solid ${_ref2 => {
  let {
    theme
  } = _ref2;
  return theme.colors.borders.primary;
}};

  th {
    padding-bottom: 1em;
  }
`;
const FindingsCard = _ref3 => {
  let {
    widget,
    ...rest
  } = _ref3;
  const {
    t
  } = useTranslation();
  const [showDismissed, setShowDismissed] = React.useState(false);
  const [showClosed, setShowClosed] = React.useState(false);
  const {
    items
  } = widget.data;
  const filteredItems = items.filter(item => !item.isClosed && !item.isDismissed || showDismissed && item.isDismissed || showClosed && item.isClosed);
  const itemsPerPage = 3;
  const [page, setPage] = useState(1);
  const totalPageCount = Math.ceil(filteredItems.length / itemsPerPage);
  const paginatedItems = filteredItems.slice((page - 1) * itemsPerPage, page * itemsPerPage);
  const handleNextPageClick = () => {
    setPage(prev => prev + 1);
    mixpanel.track(`Insights Blockers – Next Page Click`, {
      from: page
    });
  };
  const handlePrevPageClick = () => {
    setPage(prev => prev - 1);
    mixpanel.track(`Insights Blockers – Prev Page Click`, {
      from: page
    });
  };
  return /*#__PURE__*/React.createElement(Card, rest, /*#__PURE__*/React.createElement(Grid, {
    cols: 2,
    template: "1fr auto auto auto",
    gap: 2,
    s: {
      mb: 3
    },
    align: "center"
  }, /*#__PURE__*/React.createElement(Text, {
    element: "h3",
    fontSize: 8
  }, t("FindingsCard.blockersAndActionItems")), /*#__PURE__*/React.createElement(Box, {
    align: "center"
  }, filteredItems.length > itemsPerPage && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
    onClick: handlePrevPageClick,
    color: "transparent",
    disabled: page === 1,
    s: {
      p: 1
    },
    outline: false,
    rounded: true
  }, /*#__PURE__*/React.createElement(Icon, {
    scale: 5,
    display: "block",
    rotate: -90,
    src: "chevron"
  })), /*#__PURE__*/React.createElement(Text, {
    weight: "medium",
    color: "textSecondary"
  }, page, " of ", totalPageCount), /*#__PURE__*/React.createElement(Button, {
    onClick: handleNextPageClick,
    color: "transparent",
    disabled: totalPageCount <= 1 || page >= totalPageCount,
    s: {
      p: 1
    },
    outline: false,
    rounded: true
  }, /*#__PURE__*/React.createElement(Icon, {
    scale: 5,
    display: "block",
    rotate: 90,
    src: "chevron"
  }))), /*#__PURE__*/React.createElement(Dropdown, {
    "data-tooltip-id": "general-tooltip",
    "data-tooltip-content": t("common.actions.options"),
    display: "inline-block",
    direction: "bottomLeft",
    handlerProps: {
      color: showDismissed || showClosed ? "translucentPrimary" : "transparent",
      rounded: true,
      s: {
        p: 1
      }
    },
    handler: /*#__PURE__*/React.createElement(Icon, {
      scale: 5,
      display: "block",
      src: "filter"
    })
  }, _ref4 => {
    let {
      isOpen,
      onItemClick
    } = _ref4;
    return /*#__PURE__*/React.createElement(Dropdown.List, {
      isOpen: isOpen
    }, /*#__PURE__*/React.createElement(Dropdown.ListItem, {
      onClick: () => {
        onItemClick();
        setShowDismissed(prev => !prev);
      }
    }, /*#__PURE__*/React.createElement(Icon, {
      src: showDismissed ? "checkboxFill" : "checkbox",
      s: {
        mr: 2
      },
      color: "primary"
    }), "Show Dismissed"), /*#__PURE__*/React.createElement(Dropdown.ListItem, {
      onClick: () => {
        onItemClick();
        setShowClosed(prev => !prev);
      }
    }, /*#__PURE__*/React.createElement(Icon, {
      src: showClosed ? "checkboxFill" : "checkbox",
      s: {
        mr: 2
      },
      color: "primary"
    }), "Show Completed"));
  }))), filteredItems.length ? /*#__PURE__*/React.createElement(StyledTable, {
    size: "m",
    fontSize: 3.2,
    tableProps: {
      style: {
        minWidth: "1000px"
      }
    },
    s: {
      mx: -5,
      mb: -5
    }
  }, /*#__PURE__*/React.createElement(StyledTableHeader, null, /*#__PURE__*/React.createElement(Table.Tr, null, /*#__PURE__*/React.createElement(Table.Th, {
    width: "0"
  }), /*#__PURE__*/React.createElement(Table.Th, {
    width: "180px"
  }, t("FindingsCard.topic")), /*#__PURE__*/React.createElement(Table.Th, {
    width: "250px"
  }, t("FindingsCard.context")), /*#__PURE__*/React.createElement(Table.Th, {
    width: "250px"
  }, t("FindingsCard.action")), /*#__PURE__*/React.createElement(Table.Th, {
    width: "150px"
  }, t("FindingsCard.owner")), /*#__PURE__*/React.createElement(Table.Th, {
    width: "100px"
  }, t("FindingsCard.urgency")), /*#__PURE__*/React.createElement(Table.Th, {
    width: "150px"
  }, t("FindingsCard.observedAt")), /*#__PURE__*/React.createElement(Table.Th, {
    width: "0"
  }))), /*#__PURE__*/React.createElement(Table.Body, null, paginatedItems.map(item => /*#__PURE__*/React.createElement(FindingTableRow, {
    showDismissed: showDismissed,
    showClosed: showClosed,
    key: item.id,
    item: item
  })))) : /*#__PURE__*/React.createElement(Box, {
    direction: "column",
    justify: "center",
    align: "center",
    fullHeight: true
  }, /*#__PURE__*/React.createElement(StyledIcon, {
    src: "tick",
    color: "translucentSuccess"
  }), /*#__PURE__*/React.createElement(Text, {
    element: "h3",
    weight: "semiBold",
    display: "block",
    s: {
      mt: 6
    },
    align: "center",
    style: {
      maxWidth: "300px"
    }
  }, "No Blockers or Action items found")));
};
export default FindingsCard;